<template>
<div id="template_75">
   <div id="channel-container">
      <div id="template-container" class="default-scoreboard">
        <div id="content">
  
         <!-- The default scoreboard -->
         <div id="default">
   
            <!-- Live video feed something happens here -->
            <div id="media-wrapper">
               <div id="media" data-zone="zone-01">
                  <!-- <video id="video" autoplay controls="false" style="display:none;">
                     <source id="1000a" src="" type="video/mp4">
                  </video> -->

                  <img :src="GALLERY_HOST + '/' + zone5.val" :style="getImageStyle(zone5)">
               </div>
            </div>
   
            <div id="scoreboard-wrapper">
   
               <!-- Top section -->
               <div class="top score-data">

               <div class="left">
                <div class="left--top">
                  <div class="logo-wrapper">
                    <div class="team-logo home" data-zone="zone-03">
                      <img :src="GALLERY_HOST + '/' + zone1.val" :style="getImageStyle(zone1)">
                    </div>
                  </div>

                  <div class="name-score-wrapper">
                    <div class="score home"><span id='fp_home_score'>22</span></div>
                  </div>

                  <div class="timeout-wrapper">
                    <div class="home uppercase">
                      <div class="tol-label score-heading">TOL</div>
                      <span id="fp_home_to_left" class="board-number">2</span>
                    </div>
                  </div>
                </div>
                
                <div class="left--bottom">
                  <div class="team-name home uppercase" data-zone="zone-02">
                    <span id='3000'>{{zone3.val}}</span>
                  </div>
                </div>
               </div><!-- END left -->

               <div class="center time-division-wrapper">
                <div class="offense-container">
                  <div class="downs">
                    <div class="score-heading uppercase"><span>Down</span></div>
                    <div class="board-number"><span id='fp_down'>1</span></div>
                  </div>
                  <div class="to-go">
                    <div class="score-heading uppercase"><span>To Go</span></div>
                    <div class="board-number"><span id='fp_to_go'>10</span></div>
                  </div>
                  <div class="ball-on">
                    <div class="score-heading uppercase"><span>Ball On</span></div>
                    <div class="board-number"><span id='fp_ball_on'>20</span></div>
                  </div>
                </div>
                <div class="period-clock-container">
                  <div class="time-division">
                    <!-- Possession arrow; the arrow is a backgroundground image in the span; no span = no arrow -->
                    <div id='fp_fb_poss_home' class="possession home"></div>
                    
                    <div class="score-heading uppercase"><span>QTR</span></div>
                    <div class="board-number"><span id='fp_period'>0</span><sup id='period_sub'>st</sup></div>
                    
                    <!-- Possession arrow; the arrow is a backgroundground image in the span; no span = no arrow -->
                    <div id='fp_fb_poss_vis' class="possession visitor"><span></span></div>
                  </div>

                  <div id="game-clock">
                    <div class="time"><span id='fp_clock'>00:00</span></div>
                  </div>
                </div>


               </div><!-- END center -->

               <div class="right">
                <div class="right--top">
                  <div class="timeout-wrapper">
                    <div class="home uppercase">
                      <div class="tol-label score-heading">TOL</div>
                      <span id="fp_home_to_left" class="board-number">2</span>
                    </div>
                  </div>

                  <div class="name-score-wrapper">
                    <div class="score visitor"><span id='fp_vis_score'>40</span></div>
                  </div>

                  <div class="logo-wrapper">
                    <div class="team-logo visitor" data-zone="zone-05">
                      <img :src="GALLERY_HOST + '/' + zone2.val" :style="getImageStyle(zone2)">
                    </div>
                  </div>
                </div>
                
                <div class="right--bottom">
                  <div class="team-name visitor uppercase" data-zone="zone-04">
                    <span id='4000'>{{zone4.val}}</span>
                  </div>
                </div>
              </div><!-- END right -->
   
               </div> <!-- END top score-data -->
   
            </div><!-- END scoreboard-wrapper -->
   
         </div><!-- END default -->
      </div>
      </div>
   </div>
</div>
</template>

<script>
import BaseSolonScoreboardPreview from './../Solon/BaseSolonScoreboardPreview'

export default {
   extends: BaseSolonScoreboardPreview,

   data() {
      return {
         instanceRecid: '',
         zone1: {}, //home logo
         zone2: {}, //away logo
         zone3: {}, //home text
         zone4: {}, //away text
         zone5: {} //top background
      }
   },

   created() {
      this.zone1 = this.json.tmpl.assets[0];
      this.zone2 = this.json.tmpl.assets[1];
      this.zone5 = this.json.tmpl.assets[2];

      this.zone3 = this.json.tmpl.data.text[0];
      this.zone4 = this.json.tmpl.data.text[1];
   },
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" scoped>
// vars
$width: 100vw;
$height: 100vh;

// background colors 
$darken: rgba(0,0,0,0.05); 
$black: rgba(0,0,0,1); 
$white: rgba(1,1,1,1);
// $time-division: rgba(123, 124, 126, 1);
// $timeouts: rgba(28, 54, 92, 1);
// $player-stats: rgba(34, 24, 19, 0.85);

// fonts
$red: rgb(223, 30, 36);
$darkgray: rgb(93,93,93);
$team-bg: rgb(0,16,61); //blue
// $shot-clock: rgb(136,251,2);
$score: rgb(255,215,0); //gold
@mixin team-name {
  // padding-top: 4px;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1;
}

* {
  margin: 0 auto;
  padding: 0;
  border: 0;
	box-sizing: border-box;
}

#template_75 {
  position: relative;
  width: 560px;
  height: 400px;
  overflow: hidden;
  text-align: center;
  background-color: $black;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  line-height: normal;
  color: #fff;
  overflow: hidden;
  transform: scale(1.5);
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: initial;
}

.right {
  clear: right;
}

#template-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

#template-container {
  display: block;
  opacity: 1;
  visibility: visible;
  
  #content, #default {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  #media-wrapper, 
  #scoreboard-wrapper {
    
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  // Live video area 16:9 ratio; 315px on output to the display 
  #media-wrapper {
    height: 315px;
    overflow: hidden;

    #media {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: black;
    }

    img, 
    video {
      position: absolute;
    }

    video {
       max-width: 100%;
       max-height: 100%;
    }
  }
 
  #scoreboard-wrapper {
    top: 315px;
    height: 85px;
    left: 0;
    position: absolute;

   //  > div {
   //    margin: 0 auto;
   //    padding: 0 4px;
   //  }
  }

  .top {
    &.score-data {
      width: 100%;
      height: 100%;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      background-color: black;
      color: #fff;

      > div {
        flex-grow: 1;
        flex-shrink: 0;
        height: 100%;
        text-align: center;
        background-color: $black;
      }

      .left, .right {
        //flex-basis: 32%;
        // flex-basis: 178px;
        // flex-basis: 162px;
        flex-basis: 150px;
        //padding: 0 1%;
        background-color: $team-bg;
        // display: flex;
        
        .left--top,
        .right--top {
          width: 100%;
          height: 60px;
          padding-top: 2px;
          display: flex;
          justify-content: flex-start;
          
          > div  {
            flex-grow: 1;
            flex-shrink: 0;
            height: 100%;
            display: flex;
            align-items: center;
          }
        }

        .name-score-wrapper {
          //flex-basis: 42%;
          //flex-basis: 110px;
          flex-basis: 70px;
          // padding-bottom: 5px;
          // flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          .score {
            span {
              // font-size: 42px;
              font-size: 64px;
              font-weight: 700;
              line-height: 1;
              color: #fff;
            }
          }
        }

        .logo-wrapper {
          //flex-basis: 100px;
          //height: 125px;
          // flex-basis: 42px;
          flex-basis: 35px;
          // height: 85px;
          height: 60px;
          // display: flex;
          // align-items: center;

          .team-logo {
            // width: 35px;
            // height: 54px;
            width: 40px;
            height: 40px;
            position: relative;
            overflow: hidden;
          }

          img {
            position: absolute;
            max-width: unset;
            // ***** Zach, the following for img is garbage, I just put it here for visual design approval *****
          }
        }

        .timeout-wrapper {
          flex-basis: 35px;
          .score-heading {
            //font-size: 0.77vw;
            //font-size: 14px;
            font-size: 15px;
            font-weight: 700;
            color: $score;
          }
          .board-number {
            //font-size: 1.63vw;
            //font-size: 12px;
            font-size: 17px;
            font-weight: 700;
            line-height: 1;
          }
        }

        .left--bottom,
        .right--bottom {
          width: 150px;
          height: 25px;
          padding-top: 2px;
          .team-name {
            @include team-name ;
            white-space: nowrap;
            color: inherit;
          }
        }
      }

      // The center div, holds the period, game clock, offense data
      .time-division-wrapper {
        //flex-basis: 36%;
        //flex-basis: 175px;
        flex-basis: 260px;
        height: 100%;
        display: flex;
        // flex-direction: column;
        // padding: 5px 0;
        justify-content: center;
        align-items: center;

        .period-clock-container {
          // width: 100%;
          flex-basis: 150px;
          flex-grow: 1;
          height: 100%;
          //flex-basis: 60%;
          // flex-basis: 102px;
          // overflow: hidden;
          // position: relative;
          text-align: center;

          > div {
            // display: inline-block;
            // vertical-align: baseline;
            display: block;
            width: 100%;
          }

          .time-division {
            // position: absolute;
            // color: #000;
            // top: 14px;
            // left: 9px;
            text-align: center;
            
            > div {
              display: inline-block;
              vertical-align: baseline;
            }

            .score-heading {
              //font-size: 1.15vw;
              // font-size: 9px;
              // font-size: 11px;
              font-size: 19px;
              font-weight: 700;
              line-height: 1;
              //color: #4ba5da;
              color: $score;
              margin-right: 5px;

            }
            .board-number {
              color: #fff;
              // font-size: 3.3vw;
              // font-size: 17px;
              font-size: 19px;
              font-weight: 700;
              line-height: 1;

              #period_sub {
                font-size: 12px;
              }
            }
            .possession {
              width: 23px;
              height: 23px;
              // padding: 0 4px;
              padding-top: 4px;
              span {
                display: block;
                margin: auto 0;
                &::after {
                  content: '';
                  display: block;
                  width: 23px;
                  height: 23px;
                  background-image: url('assets/img/possession-arrow.svg');
                  background-repeat: no-repeat;
                  background-color: transparent;
                  background-position: center center;
                  background-size: 100%;
                }
              }
              &.visitor {
                span {
                  &::after {
                    transform: rotate(180deg);
                  }
                }
              }
            }

          }

          #game-clock {
            //font-size: 6vw;
            font-size: 52px;
            // margin-left: 42px;
            font-weight: 700;
            line-height: 1;
          }
        }

        .offense-container {
          // width: 100%;
          flex-basis: 110px;
          flex-grow: 1;
          height: 100%;
          padding-top: 6px;
          // display: flex;
          // align-items: center;
          // justify-content: space-between;
          // margin-bottom: 5px;

          > div {
            // flex: 1 0 auto;
            width: 100%;
            > div {
              // padding: 0 2px;
              display: inline-block;
              vertical-align: baseline;
              text-align: right;
            }
          }
          .score-heading {
            width: 79%;
            padding-right: 2px;
            //font-size: 1.5vw;
            // font-size: 12px;
            font-size: 19px;
            font-weight: 700;
            text-align: right;
            color: $score;
          }
          .board-number {
            width: 20%;
            //font-size: 2.25vw;
            // font-size: 16px;
            font-size: 19px;
            font-weight: 700;
            text-align: left;
          }
        }
      }
    }
  }

  //  Top section holds the team name, score, time outs, period, possesion
   //  .top {
   //    &.score-data {
   //      width: 100%;
   //      height: 100%;
   //      display: flex;
   //      flex-flow: row nowrap;
   //      background-color: $black;
   //      color: #fff;

   //      > div {
   //        flex-grow: 1;
   //        flex-shrink: 0;
   //        height: 100%;
   //        text-align: center;
   //        background-color: $black;
   //      }

   //      .left .possession {
   //          left: 4px;
   //       }

   //       .right .possession {
   //           right: 4px;
   //        }

   //      .left, .right {
   //        display: flex;
   //        flex-basis: 178px;
   //       //  padding: 0 1%;

   //        > div  {
   //          flex-grow: 1;
   //          flex-shrink: 0;
   //          height: 100%;
   //          display: flex;
   //          justify-content: flex-end;
   //          align-items: flex-end;
   //        }
          
   //        .name-score-wrapper {
   //          flex-basis: 110px;
   //          padding-bottom: 5px;
   //          flex-direction: column;
   //          position: relative;
   //        }

   //        .logo-wrapper {
   //          flex-basis: 42px;
   //          height: 85px;
   //          display: flex;
   //          align-items: center;

   //          .team-logo {
   //             width: 54px;
   //             height: 54px;
   //             position: relative;
   //             overflow: hidden;
   //          }

   //          img {
   //             position: absolute;
   //             max-width: unset;
   //          }
   //       }

   //        .possession {
   //          flex-basis: 16px;
   //          position: absolute;
   //          top: 32px;
   //          padding: 0 4px;
   //          span {
   //            margin: auto 0;
   //            &::after {
   //              content: '';
   //              display: block;
   //              width: 25px;
   //              height: 23px;
   //              background-image: url('./assets/img/possession-football.png');
   //              background-repeat: no-repeat;
   //              background-color: transparent;
   //              background-position: center center;
   //              background-size: 100%;
   //            }
   //          }
   //        }

          

   //        .timeout-wrapper {

   //          .score-heading {
   //             font-size: 12px;
   //             font-weight: 700;
   //             color: $score;
   //           }
   //           .board-number {
   //             font-size: 14px;
               
   //             margin-left: 4px;
   //           }
   //        }

   //        // team name and score lives in .name-score-wrapper
   //        .team-name {
   //          @include team-name ;
   //          white-space: nowrap;
   //          color: inherit;
   //        }
   //        .score {
   //          span {
   //            font-size: 42px;
   //            font-weight: 700;
   //            line-height: 1;
   //            color: #fff;
   //          }
   //        }
   //      }

   //      // The center div, holds the period, game clock, offense data
   //      .time-division-wrapper {
   //        flex-basis: 175px;
   //        display: flex;
   //        flex-direction: column;

   //        .period-clock-container {
   //          position: relative;
   //          width: 100%;
   //          flex-grow: 1;
   //          flex-basis: 102px;
   //          overflow: hidden;

   //          > div {
   //            display: inline-block;
   //            vertical-align: baseline;
   //          }

   //          .time-division {
   //             position: absolute;
   //            color: #000;
   //            top: 14px;
   //            left: 9px;
   //            .score-heading {
   //                font-size: 9px;
   //                font-weight: 700;
   //                color: $score;
   //             }
   //             .board-number {
   //               color: #fff;
   //               font-size: 26px;
   //               font-weight: 700;
   //               line-height: 1;
   //             }
   //          }
  
   //          #game-clock {
   //             // margin-top: 10px;
   //             margin-left: 42px;
   //            font-size: 52px;
   //            font-weight: 700;
   //          }
   //        }

   //        .offense-container {
   //          width: 100%;
   //          flex-grow: 1;
   //          display: flex;
   //          align-items: center;
   //          justify-content: space-between;
   //          margin-bottom: 5px;
   //          > div {
   //            flex: 1 0 auto;
   //            > div {
   //              padding: 0 2px;
   //              display: inline-block;
   //              vertical-align: baseline;
   //            }
   //          }
   //          .score-heading {
   //            font-size: 10px;
   //            font-weight: 700;
   //            color: $score;
   //           }
   //           .board-number {
   //              font-size: 16px;
   //              font-weight: 700;
   //           }
   //        }
   //      }
   //    }
   //  }
  }

</style>